// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3rKQ-","title":"AfterFrontImage_title__3QouM"};